module.exports = "/images/map-marker.png?19afe0cdd03df56ef6aa0be7733b4b0c";